export { default as BillPaymentConfirmation } from "./BillPaymentConfirmation";
export type {
    IBillPaymentConfirmationProps,
    IBillPaymentCTA,
    IBillPaymentContentProps,
} from "./types";
